import { Button, TextField } from '@mui/material';
import React, { useState, useContext } from 'react';
import GradientButton from '../../../../../customMui/newButton/newButton';
import MeetingPasscode from './meetingPasscode';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import callApi from '../../../../libs/callApi';
import ControllerContext from '../../../../../../RoomControllerSocketContext';
const JoinMeeting = (props) =>
{
	const { pluginSocket } = useContext(ControllerContext);
	const [ passCode, setPassCode ] = useState(false);
	const [ meetingId, setMeetingId ] = useState('');
	const [ isrecurring, setisrecurring ] = useState(false);
	const [ name, SetName ] = useState('');
	const navigate = useHistory();

	async function getMeetingDetails()
	{
		props?.setIsLoading(true);
		const data = JSON.stringify({
			'path'     : '/schedule/publicgetmeeting',
			'method'   : 'GET',
			'apiQuery' : `id=${meetingId}`
		});

		try
		{
			const response = await callApi(data);

			if (JSON.stringify(response?.status) === 'false')
			{
				toast.error(response?.data);
			}
			else
			if (response?.meetingDetails?._id)
			{

				const meetingData = { ...response?.meetingDetails, displayName: name };

				pluginSocket?.emit('startMeeting', meetingData);

				const meetingType = btoa(response?.meetingDetails?.scheduleType);
				// console.log("my join meeting --------",props?.userdetails);
				const uid = btoa(props?.userdetails?.data?.email);

				const displayName = btoa(name);

				const { controllerUniqueId, desktopUniqueId } = await window?.electron?.ipcRenderer?.invoke('requestToJoinRoom');
				const volume = await window?.electron?.ipcRenderer?.invoke('getSystemVolume');

				pluginSocket?.emit('receiveSystemVolume', { volume });

				navigate.push(`/${response?.meetingDetails?.sessionId}?projectId=${import.meta.env.VITE_ProjectId}&uid=${uid}&displayName=${displayName}&meetingType=${meetingType}&pairId=${desktopUniqueId}_${controllerUniqueId}&profileKey=${props?.userdetails?.data?.profileImage?.key ? encodeURIComponent(props?.userdetails?.data?.profileImage?.key) : ''}`);

			}
			else
			{
				const pass = JSON.stringify(response?.data.isMeetingProtected);

				if (pass === 'true')
					setPassCode(true);
				if (JSON.stringify(response?.data.isRecurring) === 'true')
					setisrecurring(true);
			}
			props?.setIsLoading(false);
		}
		catch (error)
		{
			console.log(error);
			props?.setIsLoading(false);
		}
	}
	const handleEnterPasscode = async () =>
	{

		getMeetingDetails();
		// props.setJoinMeet(false);
	};

	const handleClosePasscode = () =>
	{
		setPassCode(false);
		props.setMeet(false);

	};
	const handleMeetingIdChange = (event) =>
	{
		setMeetingId(event.target.value);
	};
	const handleName = (event) =>
	{
		SetName(event.target.value);
	};

	return (
		<>
			{!passCode && <div className='flexCol dialogBD'>
				<div className='flexCol dialogBox'>
					<div className='flexRow pdngSM aEnd jBtwn brdrBSM'>
						<span className='mHdng pdngHXS '>
							Join Meeting
						</span>
						<img
							src='/icons/Cancel.svg'
							alt='cancel'
							className='IconImage pointer'
							onClick={props?.handleCloseMeet}
						/>
					</div>
					<div className='flexCol pdngHMD'>
						<div className='flexRow pdngSM '>
							<TextField
								id='outlined-basic'
								size='large'
								fullWidth
								label={'Name'}
								variant='standard'
								name='name'
								onChange={handleName}
							/>
						</div>
						<div className='flexRow pdngSM '>
							<TextField
								id='outlined-basic'
								size='large'
								fullWidth
								label='Meeting ID'
								variant='standard'
								name='meetingId'
								inputProps={{ maxLength: 10 }}
								onChange={handleMeetingIdChange}
							/>
						</div>
						<div className='flexRow aEnd jEnd   mrgnVLG gap16'>
							<Button
								variant='outlined'
								disableElevation
								style={{ borderRadius: '10px' }}
								onClick={props?.handleCloseMeet}
							>
								Cancel
							</Button>
							<GradientButton
								variant='contained'
								disableElevation
								disabled={name==='' || meetingId.length < 10}
								onClick={handleEnterPasscode}
							>
								Start Meeting
							</GradientButton>
						</div>
					</div>
				</div>
			</div>}
			{passCode &&
			<MeetingPasscode
				setIsLoading={props?.setIsLoading}
				name={name}
				email={props?.userdetails?.data?.email}
				handleClosePasscode={handleClosePasscode}
				meetingId={meetingId}
				isrecurring={isrecurring}
			/>}

			{/* <ToastContainer
				position='top-right'
				autoClose={3000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnVisibilityChange
				draggable
				pauseOnHover
			/> */}
		</>
	);
};

export default JoinMeeting;
